import React, { useState, useEffect, useRef } from 'react'; //import React Component
import { NavLink } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { signOut } from 'firebase/auth';
import { auth, cloudStore } from '../firebase';
import { collection, query, where, doc, setDoc, updateDoc, getDocs, getDoc } from 'firebase/firestore';
import { AllMadeCard } from '../components/AllMadeCard';
import { AllChat } from '../components/AllChat';
import { AllMadeWelcome } from '../components/AllMadeWelcome';
import { Allcoupon } from '../components/Allcoupon';
import { AllOwnOrder } from '../components/AllOwnOrder';
import { Alluser } from '../components/Alluser';
import { AllOrder } from '../components/AllOrder';

export function Profile() {
    const [ifOfficer, setifOfficer] = useState(false)
    const userName = localStorage.getItem("currentLoginUser");
    let userID = localStorage.getItem("currentLoginUserID");
    const 这个是二级保证 = localStorage.getItem("这个是二级保证");
    const [userData, setuserData] = useState([])
    const [phone, setphone] = useState("")
    const [wechat, setwechat] = useState("")
    const [location, setlocation] = useState("")
    const [level, setlevel] = useState("")
    const [exp, setbuyingPower] = useState(0)
    const [test, settest] = useState(0)

    const [couponCollection, setcouponCollection] = useState([])
    useEffect(() => {
        if (userData.length > 0) {
            getDocs(query(collection(cloudStore, "userCoupon"), where("Coupon_Information.ownerID", "==", userID)))
                .then((querySnapshot) => {
                    const data = querySnapshot.docs.map((doc) => doc.data());
                    setcouponCollection(data)
                })
        }
    }, []);

    useEffect(() => {
        getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.name", "==", userName)))
            .then((querySnapshot) => {
                const data = querySnapshot.docs.map((doc) => doc.data());
                setuserData(data)
            })
    }, []);

    useEffect(() => {
        if (userData.length > 0) {
            setphone(userData[0].Personal_Information.phone)
            setwechat(userData[0].Personal_Information.wechat)
            setlocation(userData[0].Personal_Information.location)
            setlevel(userData[0].会员等级.level)
            settest(userData[0].会员等级.buyingPower)
            if (userData[0].officer === true) {
                setifOfficer(true)
            }

            let buyingPower = userData[0].会员等级.buyingPower
            let exp = 100 - buyingPower % 100
            // let newlevel = Math.floor(buyingPower / 100)
            setbuyingPower(exp)
        }
    })

    useEffect(() => {
        if (userData.length > 0 && userID !== null) {
            let buyingPower = userData[0].会员等级.buyingPower
            let newlevel = Math.floor(buyingPower / 100)
            const docData = {
                "会员等级.level": newlevel
            }
            updateDoc(doc(cloudStore, "userData", userID), docData)
            if (level !== newlevel && userID.length > 0) {
                if (couponCollection.length > 0) {
                    const existingAmounts = couponCollection[0].Coupon_Information["金额"];
                    const updatedAmounts = [...existingAmounts, newlevel - level];
                    updateDoc(doc(cloudStore, "userCoupon", userID), {
                        "Coupon_Information.金额": updatedAmounts,
                    });
                } else {
                    const docData = {
                        "Coupon_Information": {
                            ownerID: userID,
                            金额: [newlevel - level]
                        }
                    }
                    setDoc(doc(cloudStore, "userCoupon", userID), docData)
                }
            }
        }
    }, [test])

    const refLogOut = useRef('');
    const refProfileBoard = useRef('');
    const refTips = useRef('');
    useEffect(() => {
        if (userName !== null) {
            refTips.current.style.display = "none"
            refProfileBoard.current.style.display = "block"
        } else {
            refTips.current.style.display = "flex"
            refProfileBoard.current.style.display = "none"
        }
    })

    const log_out = async () => {
        localStorage.removeItem("currentLoginUser")
        localStorage.removeItem("这个是二级保证")
        await signOut(auth);
        refLogOut.current.style.display = "none"
        var tips = document.getElementById("snackbar");
        tips.className = "show";
        setTimeout(() => { tips.className = tips.className.replace("show", "disappearFade"); }, 1000);
        setTimeout(() => {
            if (window.location.pathname === "/profile") {
                window.location.reload()
            }
        }, 500);

    }

    const [ifCheckBook, setifCheckBook] = useState(false)
    const checkBook = () => {
        if (ifCheckBook) {
            setifCheckBook(false)
        } else {
            setifCheckBook(true)
        }
    }

    //(Function: ChangePage) For WelcomeBoard change page
    let [slideIndex, setslideIndex] = useState(0);
    const plusSlides = () => {
        let slides = document.querySelectorAll(".orientation ul li");
        let book = document.querySelector(".orientation ul");
        if (slideIndex < slides.length) {
            setslideIndex(slideIndex += 1)
            slides[slideIndex - 1].style.transform = "rotateY(-180deg)";
        }
        if (slideIndex === 1) {
            if ('ontouchstart' in document.documentElement) {
                book.style.transform = `translateX(${-40}px)`
            } else {
                book.style.transform = `translateX(${150}px)`
            }
        }
    }
    const minusSlides = () => {
        let slides = document.querySelectorAll(".orientation ul li");
        let book = document.querySelector(".orientation ul");
        if (slideIndex > 0) {
            setslideIndex(slideIndex -= 1)
            slides[slideIndex].style.transform = `rotateY(-${25 - slideIndex * 2}deg)`;
        }
        if (slideIndex === 0) {
            if ('ontouchstart' in document.documentElement) {
                book.style.transform = `translateX(${20}px)`
            } else {
                book.style.transform = `translateX(${-50}px)`
            }
        }
    }
    //(Function: ChangePage) --------------------------------------------------

    const [ifGiveOutCoupon, setifGiveOutCoupon] = useState(false)
    const giveOutCoupon = () => {
        if (ifGiveOutCoupon) {
            setifGiveOutCoupon(false)
        } else {
            setifGiveOutCoupon(true)
        }
    }

    const [giveTarget, setgiveTarget] = useState("")
    const [giveMoney, setgiveMoney] = useState("")
    const handleInputChange = (e) => {
        let { id, value } = e.target
        if (id === "giveTarget") {
            setgiveTarget(value)
            if (giveTarget.trim().length > 0) {
                document.getElementsByTagName("label")[0].style.color = "black"
            }
        }
        if (id === "giveMoney") {
            setgiveMoney(value)
            if (giveMoney.trim().length > 0) {
                document.getElementsByTagName("label")[1].style.color = "black"
            }
        }
    }

    const giveACoupon = async () => {
        const userName = localStorage.getItem("currentLoginUser");
        const userExist = await getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.name", "==", userName)));
        const userData = userExist.docs.map(doc => doc.data());

        const userExist2 = await getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.userID", "==", giveTarget)));
        const userData2 = userExist2.docs.map(doc => doc.data());
        var newDiv = document.createElement("div");
        var text = "";
        newDiv.classList.add("tips");
        setTimeout(() => { newDiv.style.display = "none" }, 4500);
        let button = document.querySelector(".submit");

        if (userData[0]) {
            if (userData[0].officer === true) {
                if (giveTarget.trim().length > 0 && giveMoney.trim().length > 0) {
                    if (userData2.length > 0) {
                        const dataExist = await getDocs(query(collection(cloudStore, "userCoupon"), where("Coupon_Information.ownerID", "==", giveTarget)));
                        const data = dataExist.docs.map(doc => doc.data());
                        if (data.length > 0) {
                            const docRef = doc(cloudStore, "userCoupon", giveTarget);
                            const docSnap = await getDoc(docRef);
                            const addCoupon = docSnap.exists() ? docSnap.data()["Coupon_Information"].金额 : [];
                            const updatedCoupon = [...addCoupon, parseFloat(giveMoney)];
                            updateDoc(docRef, { "Coupon_Information.金额": updatedCoupon })
                                .then(() => {
                                    var newDiv2 = document.createElement("div");
                                    var text = document.createTextNode(" Finished");
                                    newDiv2.classList.add("tips");
                                    newDiv2.appendChild(text);
                                    newDiv2.style.color = "red"
                                    button.after(newDiv2);
                                    setTimeout(() => { window.location.reload() }, 500);
                                })
                        } else {
                            const docData = {
                                "Coupon_Information": {
                                    ownerID: giveTarget,
                                    金额: [parseFloat(giveMoney)]
                                }
                            }
                            setDoc(doc(cloudStore, "userCoupon", giveTarget), docData).then(() => {
                                var newDiv2 = document.createElement("div");
                                var text = document.createTextNode(" Finished");
                                newDiv2.classList.add("tips");
                                newDiv2.appendChild(text);
                                newDiv2.style.color = "red"
                                button.after(newDiv2);
                                setTimeout(() => { window.location.reload() }, 500);
                            })
                        }
                        text = document.createTextNode("Wait for Processing. Do not Reflesh the page utill you saw the finish message");
                        newDiv.appendChild(text);
                        button.after(newDiv);

                    } else {
                        text = document.createTextNode("你填写的用户不存在.");
                        newDiv.appendChild(text);
                        button.after(newDiv);
                    }
                } else {
                    text = document.createTextNode("Please fillout the important blanks.");
                    newDiv.appendChild(text);
                    button.after(newDiv);
                    if (giveTarget.trim().length === 0) {
                        document.getElementsByTagName("label")[0].style.color = "red"
                    }
                    if (giveMoney.trim().length === 0) {
                        document.getElementsByTagName("label")[1].style.color = "red"
                    }
                }
            } else {
                text = document.createTextNode("You are not officer.");
                newDiv.appendChild(text);
                button.after(newDiv);
            }
        } else {
            text = document.createTextNode("You have not signin.");
            newDiv.appendChild(text);
            button.after(newDiv);
        }
    }

    // const onlineUsersJSON = localStorage.getItem("currentOnlineUser");
    // const onlineUsers = onlineUsersJSON ? JSON.parse(onlineUsersJSON) : [];
    // let 在线用户 = []

    // // Iterate over the onlineUsers array and display usernames
    // onlineUsers.forEach((user) => {
    //     在线用户.push(user.username)
    // });

    return (
        <div id='profile_page'>
            <Navigation />
            <main>
                <div className='profile'>
                    <div className='noUser' ref={refTips}>登录查看个人信息</div>
                    <div className="profile_content" ref={refProfileBoard}>
                        <div className="profile_body">
                            <h1>{userName}</h1>
                            {ifOfficer === true && 这个是二级保证 === "true" ?
                                <>
                                    {/* <p><strong>在线人数： {onlineUsers.length}</strong></p>
                                    <p><strong>在线用户： {在线用户}</strong></p> */}
                                </> : null

                            }
                            {ifOfficer === false && userName ?
                                <>
                                    <p><strong>手机号： {phone}</strong></p>
                                    <p><strong>微信号： {wechat}</strong></p>
                                    <p><strong>地址： {location}</strong></p>
                                    <p><strong>您的ID: {userID}</strong></p>
                                </> : null

                            }
                        </div>
                        <div className="button logout" onClick={log_out} ref={refLogOut}>Log Out</div>
                        <div id="snackbar">成功退出。</div>
                    </div>
                </div>
                {ifOfficer === true && 这个是二级保证 === "true" ?
                    <>
                        <div>
                            <h1 style={{ textAlign: "center", marginBottom: "50px" }}>请注意，您是Officer!</h1>
                            <div className='put_addPButton'>
                                <NavLink to="/addProduct">
                                    <div className='addP_button button'>Add a Product</div>
                                </NavLink>
                            </div>
                            <div className='put_addPButton'>
                                <NavLink to="/addWelcome">
                                    <div className='addP_button button' style={{ width: "325px", margin: "50px 0" }}>Add a WelcomeBoard Post</div>
                                </NavLink>
                            </div>
                            <div className='put_addPButton'>
                                <div className='addP_button button' style={{ width: "325px", margin: "50px 0" }} onClick={giveOutCoupon}>Give out Coupon</div>
                            </div>
                            {ifGiveOutCoupon === true ?
                                <>
                                    <div>
                                        <div className='forCloseFullSreen' onClick={giveOutCoupon}></div>
                                        <div className='fillCoupon'>
                                            <form>
                                                <div className='fillContent'>
                                                    <div>
                                                        <label htmlFor="giveout">给予对象ID: </label>
                                                        <input
                                                            type="text"
                                                            id="giveTarget"
                                                            placeholder="你想将优惠券给谁？"
                                                            onChange={(e) => { handleInputChange(e) }}
                                                            value={giveTarget}
                                                        />
                                                    </div>
                                                    <div>
                                                        <label htmlFor="giveout">给予对象金额: </label>
                                                        <input
                                                            type="number"
                                                            id="giveMoney"
                                                            placeholder="你想给予他多少金额？"
                                                            onChange={(e) => { handleInputChange(e) }}
                                                            value={giveMoney}
                                                        />
                                                    </div>
                                                    <div className="button submit" style={{ margin: "40px auto 0 auto" }} onClick={giveACoupon}>Submit</div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </> : null

                            }
                            <div className="collection">
                                <AllMadeCard />
                                <AllMadeWelcome />
                                <AllOrder />
                                <AllChat />
                                <Alluser />
                            </div>
                        </div>
                    </> : null

                }
                {ifOfficer === false && userName ?
                    <>
                        <div>
                            {ifCheckBook === true ?
                                <>
                                    <div className='put_addPButton'>
                                        <div className='addP_button button' style={{ width: "325px", margin: "50px 0" }} onClick={checkBook}>关闭新手指引</div>
                                    </div>
                                    <div className='orientation'>
                                        <ul>
                                            <li><div className="inner2"></div>新手指引</li>
                                            <li>如何下单：
                                                <p>1. 点击商品旁边的添加按钮，添加商品进入购物车。</p>
                                                <p>2. 点击商品可以查看商品细节。</p>
                                                <p>3. 添加完成后点击右下角的购物车进入商品总浏览。</p>
                                                <p>4. 确认无误之后点击清算时刻！</p>
                                                <p>5. 进入结算页面之后请按照要求输入全部信息。</p>
                                                <p>6. 付款之后保留截屏将付款截屏以及订单号发送给客服。</p>
                                            </li>
                                            <li>优惠券：
                                                <p>1. 优惠券一次只能使用一张。</p>
                                                <p>2. 会员等级每升一级会获得一张1$的优惠券。</p>
                                                <p>3. 优惠券不能应用于其额度高于商品总价格的订单，除此之外优惠券没有任何使用限制，可以在任何时候使用。</p>
                                                <p>4. 每消费100$，会员等级提升一级（订单显示已完成）。</p>
                                                <p>5. 会员经验只和最终商品消费有关。</p>
                                                <p>6. 优惠券无法他人赠与或赠与他人。</p>
                                                <p>7. 优惠券在订单结算页面使用，选择后自动减少总商品价格。</p>
                                                <p>8. 优惠券在订单提交前都不会被视作已使用，但是一旦提交会立刻视作被使用，从卡包中消失。</p>
                                                <p>9. 如遇订单出现问题但是优惠券没有退回，请找客服联系。</p>
                                            </li>
                                            <li>订单信息：
                                                <p>1. 订单一共有四种状态：等待确认，订单已确认，订单已取消，订单已完成</p>
                                                <p>2. 可以通过联系客服提交付款信息截屏和订单号加快进度。</p>
                                                <p>3. 如遇订单取消则该订单可能出现问题。问题会在下方显示。</p>
                                                <p>4. 订单出现问题后请立刻联系客服，尤其是使用优惠券的订单。</p>
                                                <p>5. 订单完成后，无法对订单做任何修改。如遇商品问题请立刻联系客服。</p>
                                            </li>
                                            <li>取货：
                                                <p>1. 取货有两种方式，一种是自提，一种是配送。</p>
                                                <p>2. 自提可以随时联系客服提取，配送两天配送一次。具体时间请查看主页公告板。</p>
                                                <p>3. 商品满足45$无需任何配送费用，否则一旦选择配送就需要1$配送费.</p>
                                                <p>4. 配送暂时只支持u-district以内，其他地区只能选择自取。</p>
                                            </li>
                                            <li><div className="inner2" style={{ left: "0", top: "0" }}></div></li>
                                        </ul>
                                    </div>
                                    <div className='changePage'>
                                        <div onClick={minusSlides}><span className="material-symbols-outlined" >arrow_back_ios</span></div>
                                        <div onClick={plusSlides}> <span className="material-symbols-outlined" >arrow_forward_ios</span></div>
                                    </div>
                                </> : null

                            }
                            {ifCheckBook === false ?
                                <>
                                    <div className='put_addPButton'>
                                        <div className='addP_button button' style={{ width: "325px", margin: "50px 0" }} onClick={checkBook}>查看新手指引</div>
                                    </div>
                                </> : null

                            }
                            <div className='collection'>
                                <h2 className='exp'>您的会员等级：{level}级</h2>
                                <h2 className='exp'>距离下次升级还需消费：{exp}$</h2>
                                <AllOwnOrder />
                                <Allcoupon />
                            </div>
                        </div>
                    </> : null

                }
                {ifOfficer === false && !userName ?
                    <>
                        <div>
                            <h1 style={{ textAlign: "center", marginBottom: "50px", animation: "changeColor2 3s infinite" }}>亲爱的潜在顾客？</h1>
                            <h1 style={{ textAlign: "center", marginBottom: "50px", animation: "changeColor2 3s infinite" }}>请登录或者注册呦~</h1>
                        </div>
                    </> : null

                }
            </main>
            <Footer />
        </div >
    );
}